import React from 'react';

import OverviewBatteryFeatures from './OverviewBatteryFeature';
import Searches from './Search';
import ClientSettingCode from './ClientSettingCode'
function ClientSetting(){

    return (
       
        <>
          <div className='OverviewContainer'  style={{paddingLeft: "240px", paddingRight: "80px"}}>
            <p className='dashboard_title'>Setting</p>

           <Searches />
           <ClientSettingCode />
          
          </div>
        </>
    )
}

export default ClientSetting;